import {
  SipToken,
  SipAccount,
  SipNetwork,
  PnlShareParams,
  RouteLocationRaw
} from './types';

export const CHROME_EXT_PROTOCOL = 'chrome-extension://'

export enum PlatformId {
  ExtensionIframe = 'extensionIframe',
  BrowserWeb = 'browserWeb',
  AppWebView = 'appWebView',
  Unknown = 'unknown'
}

// 消息类型
export enum FRAME_MESSAGE_TYPE {
  HEARTBEAT = "HEARTBEAT",
  GET_VERSION = "GET_VERSION",
  GET_ACCOUNT = "GET_ACCOUNT",
  GET_LOCALE = "GET_LOCALE",
  LISTEN_LOCALE = "LISTEN_LOCALE",
  GET_ROUTE = "GET_ROUTE",
  LISTEN_ROUTER_PUSH = "LISTEN_ROUTER_PUSH",
  GET_NETWORK = "GET_NETWORK",
  GET_TOKEN_MAP = "GET_TOKEN_MAP",
  GET_STORAGE = "GET_STORAGE",
  SIGN_MESSAGE = "SIGN_MESSAGE",
  VISIT_TOKEN = "VISIT_TOKEN",
  GET_FAVORITE_LIST = "GET_FAVORITE_LIST",
  SWITCH_FAVORITE = "SWITCH_FAVORITE",
  SEND_TO_BACKGROUND_FROM_ACTION = "SEND_TO_BACKGROUND_FROM_ACTION",
  TRANSACTION_SIGNER = "TRANSACTION_SIGNER",
}

export interface PlatformService {
  platformId: PlatformId
  heartbeat(count: number, needStat?: boolean): Promise<{ count: number }>
  getVersion(): Promise<{ version: string }>;
  getLocale(): Promise<{ locale: string }>;
  listenLocale(listener: (locale: string) => void): () => void;
  getRoute(): Promise<{ route: RouteLocationRaw }>;
  listenRouterPush(listener: (to: any) => void): () => void;
  getAccount(): Promise<SipAccount>;
  getNetwork(): Promise<SipNetwork>;
  getTokenMap(): Promise<Record<string, SipToken>>;
  getFavoriteList(): Promise<SipToken[]>;
  getStorage(): Promise<{
    SipExtMain: Record<string, any>
    SipExtTradeSettings: Record<string, any>
  }>;
  signMessage(message: string, account?: SipAccount): Promise<string>;
  visitToken(token: SipToken): Promise<void>;
  switchFavorite(token: SipToken): Promise<void>;
  sendToBackgroundFromAction(message: string): Promise<any>;
  pnlShare?(params: PnlShareParams): Promise<void>;
}

export type ServiceOptions = {
  isDev?: boolean
}

export class PlatformBaseService implements PlatformService {
  platformId = PlatformId.Unknown
  options: ServiceOptions = {
    isDev: false
  }

  constructor(options?: ServiceOptions) {
    this.options = { ...this.options, ...options }
  }

  heartbeat(count: number, needStat?: boolean): ReturnType<PlatformService['heartbeat']> {
    throw new Error("Method not implemented.");
  }

  getVersion(): ReturnType<PlatformService['getVersion']> {
    throw new Error("Method not implemented.");
  }

  getAccount(): ReturnType<PlatformService['getAccount']> {
    throw new Error("Method not implemented.");
  }

  getLocale(): ReturnType<PlatformService['getLocale']> {
    throw new Error("Method not implemented.");
  }

  listenLocale(listener: any): ReturnType<PlatformService['listenLocale']> {
    throw new Error("Method not implemented.");
  }

  getRoute(): ReturnType<PlatformService['getRoute']> {
    throw new Error("Method not implemented.");
  }

  listenRouterPush(listener: any): ReturnType<PlatformService['listenRouterPush']> {
    throw new Error("Method not implemented.");
  }

  getNetwork(): ReturnType<PlatformService['getNetwork']> {
    throw new Error("Method not implemented.");
  }

  getFavoriteList(): ReturnType<PlatformService['getFavoriteList']> {
    throw new Error("Method not implemented.");
  }

  getTokenMap(): ReturnType<PlatformService['getTokenMap']> {
    throw new Error("Method not implemented.");
  }

  getStorage(): ReturnType<PlatformService['getStorage']> {
    throw new Error("Method not implemented.");
  }
  signMessage(message: string, account?: SipAccount): ReturnType<PlatformService['signMessage']> {
    throw new Error("Method not implemented.");
  }
  visitToken(token: SipToken): ReturnType<PlatformService['visitToken']> {
    throw new Error("Method not implemented.");
  }
  switchFavorite(token: SipToken): ReturnType<PlatformService['switchFavorite']> {
    throw new Error("Method not implemented.");
  }
  sendToBackgroundFromAction(message: string): ReturnType<PlatformService['sendToBackgroundFromAction']> {
    throw new Error("Method not implemented.");
  }
}
